export enum TabVariant {
  Default = 'default',
  Button = 'button',
  Underline = 'underline',
}

export enum TabSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}
